"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _breakpoints = require("../../styles/breakpoints");
var _HBButton = _interopRequireDefault(require("../HBButton/HBButton"));
var _useDetectScroll2 = require("./useDetectScroll");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ActionButtons(_ref) {
  var align = _ref.align,
    sticky = _ref.sticky,
    primaryAction = _ref.primaryAction,
    secondaryAction = _ref.secondaryAction,
    containerRef = _ref.containerRef;
  var _useDetectScroll = (0, _useDetectScroll2.useDetectScroll)({
      elementRef: containerRef
    }),
    isScrolledToEnd = _useDetectScroll.isScrolledToEnd;
  if (!primaryAction && !secondaryAction) {
    return null;
  }
  var secondaryActionJsx = secondaryAction && /*#__PURE__*/_react["default"].createElement(_HBButton["default"], {
    buttonTheme: "secondary-invisible-primary",
    onClick: secondaryAction.onClick,
    testId: secondaryAction.testId,
    testIdName: secondaryAction.testIdName,
    loading: secondaryAction.loading
  }, secondaryAction.text);
  var isAlignStart = align === 'start';
  return /*#__PURE__*/_react["default"].createElement(Container, {
    $align: align,
    $sticky: sticky,
    $isScrolledToEnd: isScrolledToEnd
  }, !isAlignStart && secondaryActionJsx, primaryAction && /*#__PURE__*/_react["default"].createElement(_HBButton["default"], {
    onClick: primaryAction.onClick,
    testId: primaryAction.testId,
    testIdName: primaryAction.testIdName,
    loading: primaryAction.loading
  }, primaryAction.text), isAlignStart && secondaryActionJsx);
}
var _default = exports["default"] = ActionButtons; // -------------------------- Styles -------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "ActionButtons__Container",
  componentId: "sc-r7zunp-0"
})(["width:100%;display:flex;gap:12px;", "{> *{flex:1;}}", ""], _breakpoints.upToMedium, function (_ref2) {
  var $align = _ref2.$align,
    $sticky = _ref2.$sticky,
    $isScrolledToEnd = _ref2.$isScrolledToEnd;
  return (0, _styledComponents.css)(["flex-wrap:", ";justify-content:", ";", " ", " ", ""], $align === 'start' ? 'wrap' : 'wrap-reverse', $align === 'start' ? 'flex-start' : $align === 'center' ? 'center' : 'flex-end', $sticky && (0, _styledComponents.css)(["position:sticky;background:white;z-index:1;", ""], !$isScrolledToEnd && (0, _styledComponents.css)(["box-shadow:0 -2px 4px 0 rgba(0,0,0,0.1);top:0;"])), $sticky === 'top' && (0, _styledComponents.css)(["top:0;"]), $sticky === 'bottom' && (0, _styledComponents.css)(["bottom:0;padding:16px;"]));
});
//# sourceMappingURL=ActionButtons.js.map